// Hook do edycji modułu DevStudio

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPutModuleRequest {
  id: number;
  name: string;
}

const putModule = ({ id, name }: IPutModuleRequest): Promise<void> =>
  axios.put(`/panel/dev-studio/modules/${id}`, { name });

export const usePutModule = (
  options?: UseMutationOptions<void, IError, IPutModuleRequest>
) => useMutation<void, IError, IPutModuleRequest>(putModule, options);
